import React from 'react';
import { componentService } from 'js/services/component.service';

export const TermsConditions = React.lazy(() => import(/* webpackChunkName: "terms-conditions" */ './TermsConditions'));

// <hub2-terms-conditions></hub2-terms-conditions>
componentService.registerWebContentComponents({ TermsConditions });
